import { useEffect, useSyncExternalStore } from 'react';

/**
 * A short status the tab shows instead of the page's title, e.g. «(3) Zu prüfen» while pages wait
 * for the reviewer, so a tab in the background says when to come back. One view sets it at a time.
 */
let badge: string | null = null;
const listeners = new Set<() => void>();

function setTitleBadge(next: string | null) {
  if (next === badge) return;
  badge = next;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** The badge to show, for DocumentTitle. */
export function useTitleBadgeValue(): string | null {
  return useSyncExternalStore(
    subscribe,
    () => badge,
    () => null,
  );
}

/** Shows `text` as the tab title while the calling view is mounted; null shows the page's own title. */
export function useTitleBadge(text: string | null) {
  useEffect(() => {
    setTitleBadge(text);
    return () => {
      setTitleBadge(null);
    };
  }, [text]);
}
